import { type MessageDescriptor } from "react-intl";

import { AssessmentCopyVariants } from "./assessment-copy.types";

/**
 * @param {AssessmentCopyVariants} variants - the assessment- and survey-worded messages for one string
 * @param {boolean} isSurvey - whether the assessment is flagged as an org survey
 * @returns {MessageDescriptor} the variant matching the flag
 */
export function pickAssessmentCopyVariant({
  variants,
  isSurvey,
}: {
  variants: AssessmentCopyVariants;
  isSurvey: boolean;
}): MessageDescriptor {
  return isSurvey ? variants.survey : variants.assessment;
}
